import { RVReadMore } from "../RVReadMore/RVReadMore";
import { RVEntityTag, Tag } from "./RVEntityTag";

import styles from "./RVEntityTags.module.scss";

/**
 * Props for the RVEntityTags component
 */
type RVEntityTagsProps = {
    /** Array of tags to display. If empty or undefined, displays a dash placeholder */
    tags?: Array<Tag>;
    /** Data test ID for the empty state element, defaults to "no-entity-tags" */
    dataTestId?: string;
};

/**
 * A component that displays a collection of entity tags with read more/less functionality.
 * When tags are present, they are displayed in a collapsible container that shows up to 3 rows.
 * When no tags are present, displays a dash placeholder.
 *
 * @param tags - Optional array of tag objects to display
 * @param dataTestId - Optional test ID for the empty state, defaults to "no-entity-tags"
 * @returns A container with tags or a placeholder if no tags exist
 */
export function RVEntityTags({ tags, dataTestId = "no-entity-tags" }: RVEntityTagsProps) {
    const hasTags = (tags?.length || 0) > 0;

    return (
        <>
            {hasTags ? (
                <RVReadMore rows={3} className={styles.tagsContainer} hideEllipsesSpan>
                    {tags?.map((tag: Tag) => (
                        <RVEntityTag key={`entity-tag-${tag.id}`} tag={tag} />
                    ))}
                </RVReadMore>
            ) : (
                <span data-testid={dataTestId}> - </span>
            )}
        </>
    );
}
